import { yupResolver } from "@hookform/resolvers/yup";
import { PencilSimple, Trash } from "phosphor-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import ActionButton from "../../../components/ActionButton";
import Button from "../../../components/Button";
import Input from "../../../components/Input";
import ItemsList, { HeaderList, ListItem } from "../../../components/ItemsList";
import ModalAction from "../../../components/ModalAction";
import PageTitle from "../../../components/PageTitle";
import TabSwitcher from "../../../components/TabSwitcher";
import Template from "../../../components/Template";
import { adicionarUnidade, alterarUnidade, excluirUnidade, obterListaUnidade } from '../../../services/api/Configuracoes/Unidade/index';
import { IAlterarUnidade, IObterListaUnidade } from '../../../services/models/Configuracoes/Unidade/index';
import * as S from "../style";
import { usePermissionsStore } from "../../../stores/PermissionsStore";

const AddUnitSchema = yup.object({
    descricao: yup.string().required("O nome é obrigatório.")
})

interface item extends IObterListaUnidade { }

const Unit = () => {
    const [view, setView] = useState<number>(0)
    const [UnitList, setUnitList] = useState<any>(null)

    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)
    const [showEditModal, setShowEditModal] = useState<boolean>(false)
    const [itemToDelete, setItemToDelete] = useState<item | null>(null)
    const [itemToEdit, setItemToEdit] = useState<item | null>(null)

    useEffect(() => {
        view === 0 && ObterListaUnidade()
    }, [view])

    const {
        handleSubmit,
        control,
        reset,
        formState: {
            errors,
            isValid
        }
    } = useForm({
        mode: "onChange",
        reValidateMode: "onChange",
        resolver: yupResolver(AddUnitSchema)
    })

    const ObterListaUnidade = async () => {
        let res = await obterListaUnidade()
        setUnitList(res)
    }

    const AdicionarUnidade = async (data: any) => {
        let body = {
            ...data
        }

        await adicionarUnidade(body).then(() => {
            reset({
                descricao: null
            })
        })
    }

    const ExcluirUnidade = async (idUnidade: number) => {
        await excluirUnidade({ idUnidade })
        ObterListaUnidade()
    }

    const EditarUnidade = async (newUnidade: IAlterarUnidade) => {
        await alterarUnidade(newUnidade)
        ObterListaUnidade()
    }

    const handleShowDeleteModal = (item: item) => {
        setItemToDelete(item)
        setShowDeleteModal(true)
    }

    const handleShowEditModal = (item: item) => {
        setItemToEdit(item)
        setShowEditModal(true)
    }

    const findPermission = usePermissionsStore((state) => state.findPermission);

    const permissions = findPermission(10);

    // PARA TESTE
    // const permissions = {
    //     permiteInserir: false,
    //     permiteAlterar: false,
    //     permiteExcluir: false,
    // }

    const {
        permiteInserir,
        permiteAlterar,
        permiteExcluir
    } = permissions;

    const menuItems = permiteInserir ?
        [
            "Dados",
            "Adicionar"
        ] : [
            "Dados"
        ]

    const headerList = permiteAlterar || permiteExcluir ?
        [
            "Descrição",
            "Status",
            "Ações"
        ] : [
            "Descrição",
            "Status"
        ]


    return (
        <Template>
            <PageTitle>
                Unidade
            </PageTitle>
            <TabSwitcher
                list={menuItems}
                view={view}
                setView={setView}
            />
            <S.Content>
                <S.ControlView active={view === 0}>
                    {
                        UnitList ? (
                            <ItemsList>
                                <HeaderList items={headerList} />
                                {
                                    UnitList.map((item: item, index: any) => {
                                        return (
                                            <ListItem key={index}>
                                                <div>{item.descricao}</div>
                                                <div>{item.isAtivo ? "Ativo" : "Inativo"}</div>
                                                {
                                                    (
                                                        permiteAlterar ||
                                                        permiteExcluir
                                                    ) && (
                                                        <div>
                                                            {
                                                                permiteAlterar && (
                                                                    <ActionButton act="edit" onClick={() => handleShowEditModal(item)}>
                                                                        <PencilSimple />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                            {
                                                                permiteExcluir && (
                                                                    <ActionButton act="delete" onClick={() => handleShowDeleteModal(item)}>
                                                                        <Trash />
                                                                    </ActionButton>
                                                                )
                                                            }
                                                        </div>
                                                    )
                                                }
                                            </ListItem>
                                        )
                                    })
                                }
                            </ItemsList>
                        ) : (
                            <p>Carregando ...</p>
                        )
                    }
                </S.ControlView>
                <S.ControlView active={view === 1} id="addRisk" onSubmit={handleSubmit((data) => AdicionarUnidade(data))}>
                    <S.GridItem cols={2}>
                        <Input
                            id="descricao"
                            name="descricao"
                            label="Descrição"
                            control={control}
                            error={errors.descricao?.message}
                        />
                    </S.GridItem>
                    {
                        isValid && (
                            <S.GridItem cols={6}>
                                <Button type="submit" form="addRisk">Adicionar</Button>
                            </S.GridItem>
                        )
                    }
                </S.ControlView>
            </S.Content>
            {
                showDeleteModal && itemToDelete && (
                    <ModalAction
                        type="delete"
                        onConfirm={() => ExcluirUnidade(itemToDelete.id)}
                        onClose={() => setShowDeleteModal(false)}
                        title="Excluir Unidade"
                        item={itemToDelete}
                    />
                )
            }
            {
                showEditModal && itemToEdit && (
                    <ModalAction
                        type="edit"
                        onConfirm={(e) => EditarUnidade(e)}
                        onClose={() => setShowEditModal(false)}
                        title="Editar Unidade"
                        item={itemToEdit}
                    />
                )
            }
        </Template>
    )
}

export default Unit